import { LoadingAnimation } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const FadedBackground = styled.div(({ theme }) => ({
  background: "white",
  borderRadius: "4px",
  bottom: 0,
  boxShadow: theme.shadows.medium,
  height: "40px",
  left: "calc(50% + 128px)",
  opacity: 0,
  padding: "8px",
  position: "absolute",
  transform: "translate(calc(-50% - 64px), -50%)",
  transition: "opacity ease-in 500ms",
  width: "272px",
  zIndex: 10,
}));

const LoadingPosition = styled.div`
  position: absolute;
  left: calc(50% + 128px);
  bottom: 16px;
  transform: translate(calc(-50% - 64px), -50%);
  height: 24px;
  z-index: 11;
  transition: opacity ease-in 500ms;
  opacity: 0;
`;

export default function ScheduleLoadingAnimation({ fetching }) {
  return (
    <>
      <FadedBackground style={{ opacity: fetching ? 1 : 0 }} />
      <LoadingPosition style={{ opacity: fetching ? 1 : 0 }}>
        <LoadingAnimation />
      </LoadingPosition>
    </>
  );
}
